export { default } from "./ResponsiveImage";
